import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	opensInNewWindow: {
		id: 'packages-components-external-link-button.opens-in-new-window',
		defaultMessage: 'Opens in a new window',
		description: 'Label for the opens in a new window icon',
	},
});
